"use client";

import { AdvancedFeaturesSection } from "@/components/sections/advanced-features";
import { advancedFeatures } from "@/lib/data/services-digital-listening";

export function AdvancedFeatures() {
  return (
    <AdvancedFeaturesSection
      eyebrow={advancedFeatures.eyebrow}
      title={advancedFeatures.title}
      sectionAccent={advancedFeatures.sectionAccent}
      features={advancedFeatures.features}
    />
  );
}
